import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CustomerMobileCard = ({ customer, onViewDetails, onViewOrders }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'active':
        return 'bg-success/10 text-success';
      case 'inactive':
        return 'bg-muted text-muted-foreground';
      case 'vip':
        return 'bg-primary/10 text-primary';
      default:
        return 'bg-muted text-muted-foreground';
    }
  };

  const getStatusLabel = (status) => {
    switch (status) {
      case 'active':
        return '활성';
      case 'inactive':
        return '비활성';
      case 'vip':
        return 'VIP';
      default:
        return status;
    }
  };

  return (
    <div className="rounded-lg bg-card p-4 shadow-card">
      <div className="mb-3 flex items-start justify-between">
        <div className="flex items-center space-x-3">
          <div className="flex h-12 w-12 items-center justify-center rounded-full bg-primary/10">
            <Icon name="User" size={24} color="var(--color-primary)" />
          </div>
          <div>
            <p className="font-medium text-foreground">{customer?.name}</p>
            <p className="text-sm text-muted-foreground">{customer?.phone}</p>
          </div>
        </div>
        <span className={`inline-flex items-center rounded-full px-3 py-1 text-xs font-medium ${getStatusColor(customer?.status)}`}>
          {getStatusLabel(customer?.status)}
        </span>
      </div>
      <div className="space-y-2 border-t border-border pt-3">
        <div className="flex items-center justify-between text-sm">
          <span className="text-muted-foreground">가입일</span>
          <span className="text-foreground">{customer?.registrationDate}</span>
        </div>
        <div className="flex items-center justify-between text-sm">
          <span className="text-muted-foreground">총 주문</span>
          <span className="font-medium text-accent">{customer?.totalOrders}건</span>
        </div>
        <div className="flex items-center justify-between text-sm">
          <span className="text-muted-foreground">최근 주문</span>
          <span className="text-foreground">{customer?.lastOrderDate}</span>
        </div>
        <div className="flex items-center justify-between text-sm">
          <span className="text-muted-foreground">총 결제액</span>
          <span className="font-medium text-foreground">
            {customer?.totalSpent?.toLocaleString('ko-KR')}원
          </span>
        </div>
      </div>
      <div className="mt-4 flex space-x-2">
        <Button
          variant="outline"
          size="sm"
          iconName="Eye"
          fullWidth
          onClick={() => onViewDetails(customer)}
        >
          상세보기
        </Button>
        <Button
          variant="outline"
          size="sm"
          iconName="Package"
          fullWidth
          onClick={() => onViewOrders(customer)}
        >
          주문내역
        </Button>
      </div>
    </div>
  );
};

export default CustomerMobileCard;